const pagination = {
  pageSize: "Page Size",
  all: "All",
};

export default pagination;
